var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldPhysicalAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.29 11.9679C17.2911 12.1425 17.2577 12.3157 17.1919 12.4774C17.126 12.6392 17.0289 12.7864 16.9062 12.9107C16.7834 13.0349 16.6374 13.1338 16.4764 13.2016C16.3154 13.2694 16.1427 13.3048 15.968 13.3059C15.7933 13.3049 15.6204 13.2696 15.4594 13.2019C15.2983 13.1341 15.1521 13.0353 15.0293 12.911C14.9064 12.7868 14.8092 12.6395 14.7433 12.4777C14.6774 12.3158 14.644 12.1426 14.645 11.9679C14.6441 11.7932 14.6776 11.6201 14.7436 11.4584C14.8096 11.2966 14.9068 11.1495 15.0296 11.0254C15.1525 10.9012 15.2986 10.8025 15.4596 10.7348C15.6206 10.6671 15.7934 10.6318 15.968 10.6309C16.698 10.6309 17.29 11.2299 17.29 11.9679Z",
    fill: "url(#paint0_linear_11330_5157)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1322 7.40711C17.2832 7.28711 16.1902 7.28711 14.8272 7.28711H9.17318C7.81018 7.28711 6.71718 7.28711 5.86818 7.40711C4.99118 7.53211 4.26018 7.79911 3.71618 8.42711C3.17318 9.05511 3.00618 9.82311 3.00018 10.7201C2.99418 11.5861 3.13918 12.6821 3.31918 14.0481L3.68418 16.8201C3.82518 17.8881 3.93918 18.7531 4.11618 19.4301C4.30118 20.1341 4.57318 20.7181 5.08418 21.1701C5.59418 21.6231 6.20418 21.8191 6.91818 21.9101C7.60518 21.9991 8.46818 21.9991 9.53318 21.9991H14.4672C15.5322 21.9991 16.3952 21.9991 17.0822 21.9111C17.7972 21.8191 18.4052 21.6231 18.9162 21.1711C19.4272 20.7181 19.6992 20.1341 19.8842 19.4301C20.0612 18.7531 20.1752 17.8881 20.3162 16.8201L20.6812 14.0481C20.8612 12.6821 21.0062 11.5861 21.0002 10.7201C20.9932 9.82311 20.8282 9.05511 20.2842 8.42711C19.7402 7.79911 19.0092 7.53211 18.1322 7.40711ZM6.05218 8.73111C5.32618 8.83511 4.95818 9.02311 4.71218 9.30811C4.46418 9.59311 4.32818 9.98711 4.32218 10.7291C4.31718 11.4901 4.44818 12.4931 4.63718 13.9241L4.68718 14.3031L5.05818 14.0311C6.01818 13.3281 7.43418 13.3631 8.34618 14.1261L11.7302 16.9591C12.0502 17.2271 12.6012 17.2771 12.9992 17.0431L13.2342 16.9041C14.3592 16.2421 15.8682 16.3121 16.9062 17.0941L18.7382 18.4741C18.8282 17.9791 18.9092 17.3701 19.0112 16.5991L19.3632 13.9241C19.5522 12.4941 19.6832 11.4901 19.6772 10.7291C19.6722 9.98711 19.5362 9.59311 19.2892 9.30911C19.0422 9.02311 18.6742 8.83511 17.9472 8.73111C17.2022 8.62511 16.2022 8.62411 14.7752 8.62411H9.22518C7.79818 8.62411 6.79718 8.62511 6.05218 8.73111Z",
    fill: "url(#paint1_linear_11330_5157)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.87977 4.5C5.62777 4.5 4.60077 5.34 4.25877 6.454C4.2518 6.47724 4.24513 6.50058 4.23877 6.524C4.59677 6.404 4.96877 6.324 5.34677 6.271C6.31877 6.132 7.54777 6.132 8.97577 6.132H15.1778C16.6058 6.132 17.8348 6.132 18.8078 6.271C19.1848 6.324 19.5578 6.403 19.9158 6.524C19.9094 6.50058 19.9027 6.47724 19.8958 6.454C19.5528 5.34 18.5258 4.5 17.2758 4.5H6.87977Z",
    fill: "url(#paint2_linear_11330_5157)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.85931 2H15.1413C15.3503 2 15.5113 2 15.6513 2.015C16.13 2.06859 16.5847 2.25296 16.9655 2.54789C17.3464 2.84282 17.6387 3.23693 17.8103 3.687H6.19031C6.36196 3.23693 6.65423 2.84282 7.03507 2.54789C7.41591 2.25296 7.87061 2.06859 8.34931 2.015C8.48931 2 8.64931 2 8.85931 2Z",
    fill: "url(#paint3_linear_11330_5157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11330_5157",
    x1: 14.645,
    y1: 11.9684,
    x2: 17.291,
    y2: 11.9684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11330_5157",
    x1: 3,
    y1: 14.6431,
    x2: 21.0004,
    y2: 14.6431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11330_5157",
    x1: 4.23877,
    y1: 5.512,
    x2: 19.9158,
    y2: 5.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11330_5157",
    x1: 6.19031,
    y1: 2.8435,
    x2: 17.8103,
    y2: 2.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldPhysicalAlbum);
export default __webpack_public_path__ + "static/media/gold-physical-album.aa5e7cf2a78c265c7cfe69aed3870510.svg";
export { ForwardRef as ReactComponent };